export default {
  welcome: 'Powitanie',
  we_miss_you: 'Tęsknimy za Tobą',
  happy_friday: 'Szczęśliwego piątku',
  lazy_sunday: 'Leniwa niedziela',
  loyalty_program: 'Program lojalnościowy',
  you_might_also_like: 'Może Ci się spodobać',
  storefront_promo: 'Promocja sklepu',
  welcome_members_club: 'Witaj w klubie członkowskim',
  launch_deal: 'Oferta na start',
};
